/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web192032.css";

function Web192032(props) {
  const { x45750896405_3918F5Bbab_K, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-32 screen">
        <div className="overlap-group1-7">
          <img className="x45750896405_3918f5bbab_k-1" src={x45750896405_3918F5Bbab_K} />
          <div className="rectangle-2-14 border-1px-dove-gray"></div>
          <div className="overlap-group-14">
            <div className="group-141-1">
              <div className="group-140-1">
                <div className="group-139-1">
                  <img className="group-138-1" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128-1" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web192032;
